module.exports = __webpack_public_path__ + "img/郭宇昕.ba3a5bba.jpg";